export default __webpack_public_path__ + "static/media/arrowRight.9c17040f.svg";